import makeRpcCall from '../../../../../util/jquery_rpc'
import AccrualRulesCell from '../../../userList/table/AccrualRulesCell'
import ResetRulesCell  from '../../../userList/table/ResetRulesCell'

const USER_BATCH_SIZE = 500

export class UserInfoRepository {
    userListOrder = {}
    filter = {}
    tokens = []
    userCount = 0
    balanceHoursPerDay = 0

    updateUserListOrder(userListOrder) {
        this.userListOrder  = userListOrder
    }

    updateFilter(filter) {
        this.filter = filter
    }

    updateTokens(tokens) {
        this.tokens = tokens
    }

    updateUserCount(userCount) {
        this.userCount = userCount
    }

    updateBalanceHoursPerDay(balanceHoursPerDay) {
        this.balanceHoursPerDay = balanceHoursPerDay
    }

    _convertUserToInfo(user, ptoDefaults, sickDaysDefaults) {
        let currentPtoBalance = null
        let plannedPtoBalanceApproved = null
        let isDefaultPtoRule = null
        let ptoAccrualRule = null
        let ptoResetRule = null
        let ptoLimit = null

        let currentSickDaysBalance = null
        let plannedSickDaysBalanceApproved = null
        let isDefaultSickDaysRule = null
        let sickDaysAccrualRule = null
        let sickDaysResetRule = null
        let sickDaysLimit = null

        const ptoFormatter = new PTOFormatter().init(this.balanceHoursPerDay, SystemSettings.roundPTOBalanceOnUserlist)
        const ptoAccrualRuleFormatter = new AccrualRulesCell().init((value) => ptoFormatter.format(value), {})
        const ptoResetRuleFormatter = new ResetRulesCell().init((value) => ptoFormatter.format(value), {})

        const sickDaysBalanceFormatter = new SickFormatter().init(this.balanceHoursPerDay, SystemSettings.roundSickBalanceOnUserlist)
        const sickDaysAccrualRuleFormatter = new AccrualRulesCell().init((value) => sickDaysBalanceFormatter.format(value), {})
        const sickDaysResetRuleFormatter = new ResetRulesCell().init((value) => sickDaysBalanceFormatter.format(value), {})

        if (user.currentPTOBalance && user.currentPTOBalance.balance !== undefined) {
            currentPtoBalance = ptoFormatter.format(user.currentPTOBalance.balance)
        }

        if (user.currentPTOBalance && user.currentPTOBalance.plannedBalanceApproved !== undefined) {
            plannedPtoBalanceApproved = ptoFormatter.format(user.currentPTOBalance.plannedBalanceApproved)
        }

        if (user.currentPTOBalance && user.currentPTOBalance.defaultRules !== undefined) {
            isDefaultPtoRule = user.currentPTOBalance.defaultRules
        }

        if (user.currentPTOBalance && user.currentPTOBalance.accrualRule) {
            ptoAccrualRule = ptoAccrualRuleFormatter._getRuleValue(user.currentPTOBalance)
        }

        if (user.currentPTOBalance && user.currentPTOBalance.resetRule) {
            ptoResetRule = ptoResetRuleFormatter._getRuleValue(user.currentPTOBalance)
        }

        if (user.currentPTOBalance && user.currentPTOBalance.balanceCap) {
            ptoLimit = ptoFormatter.format(user.currentPTOBalance.balanceCap)
        }

        if (isDefaultPtoRule && ptoDefaults) {
            ptoAccrualRule = ptoAccrualRuleFormatter._getRuleValue(ptoDefaults)
            ptoResetRule = ptoResetRuleFormatter._getRuleValue(ptoDefaults)
            ptoLimit = ptoFormatter.format(ptoDefaults.balanceCap)
        }

        if (user.currentSickDaysBalance && user.currentSickDaysBalance.balance !== undefined) {
            currentSickDaysBalance = sickDaysBalanceFormatter.format(user.currentSickDaysBalance.balance)
        }

        if (user.currentSickDaysBalance && user.currentSickDaysBalance.plannedBalanceApproved !== undefined) {
            plannedSickDaysBalanceApproved = sickDaysBalanceFormatter.format(user.currentSickDaysBalance.plannedBalanceApproved)
        }

        if (user.currentSickDaysBalance && user.currentSickDaysBalance.defaultRules !== undefined) {
            isDefaultSickDaysRule = user.currentSickDaysBalance.defaultRules
        }

        if (user.currentSickDaysBalance && user.currentSickDaysBalance.accrualRule) {
            sickDaysAccrualRule = sickDaysAccrualRuleFormatter._getRuleValue(user.currentSickDaysBalance)
        }

        if (user.currentSickDaysBalance && user.currentSickDaysBalance.resetRule) {
            sickDaysResetRule = sickDaysResetRuleFormatter._getRuleValue(user.currentSickDaysBalance)
        }

        if (user.currentSickDaysBalance && user.currentSickDaysBalance.balanceCap) {
            sickDaysLimit = sickDaysBalanceFormatter.format(user.currentSickDaysBalance.balanceCap)
        }

        if (isDefaultSickDaysRule && sickDaysDefaults) {
            sickDaysAccrualRule = sickDaysAccrualRuleFormatter._getRuleValue(sickDaysDefaults)
            sickDaysResetRule = sickDaysResetRuleFormatter._getRuleValue(sickDaysDefaults)
            sickDaysLimit = sickDaysBalanceFormatter.format(sickDaysDefaults.balanceCap)
        }

        return {
            id: user.id,
            isPtoOn: user.currentPTOBalance,
            currentPtoBalance: currentPtoBalance,
            plannedPtoBalanceApproved: plannedPtoBalanceApproved,
            isDefaultPtoRule: isDefaultPtoRule,
            ptoAccrualRule: ptoAccrualRule,
            ptoResetRule: ptoResetRule,
            ptoLimit: ptoLimit,
            isSickDaysOn: user.currentSickDaysBalance,
            currentSickDaysBalance: currentSickDaysBalance,
            plannedSickDaysBalanceApproved: plannedSickDaysBalanceApproved,
            isDefaultSickDaysRule: isDefaultSickDaysRule,
            sickDaysAccrualRule: sickDaysAccrualRule,
            sickDaysResetRule: sickDaysResetRule,
            sickDaysLimit: sickDaysLimit,
        }
    }

    load() {
        const userCount = this.userCount
        const pageCount = Math.floor(userCount / USER_BATCH_SIZE)
        const pageNumArray = Array.from({ length: pageCount + 1 }, (_, index) => index + 1)
        const filter = { ...this.filter }
        const tokens = [...this.tokens]
        const userListOrder = { ...this.userListOrder}

        return pageNumArray.map((pageNum) => {
            const userStartNum = (pageNum - 1) * USER_BATCH_SIZE
            const userEndNum = Math.min(pageNum * USER_BATCH_SIZE, userCount)

            return new Promise((res) => {
                const params = [
                    filter,
                    tokens,
                    userListOrder,
                    pageNum,
                    USER_BATCH_SIZE
                ]

                this.rpcRequest = makeRpcCall(
                    "UserManagementService.getUsers",
                    params,
                    (data) => {
                        const users = data.records.map((user) => this._convertUserToInfo(user, data.ptoDefaults, data.sdbDefaults))
                        res({
                            start: userStartNum,
                            end: userEndNum,
                            items: users
                        })
                    },
                    function ( jqXHR, textStatus, errorThrown ) {
                       if (textStatus === 'abort')
                           return;

                       if(errorThrown && !!errorThrown.exception) {
                           alert(errorThrown.exception);
                           return true;
                       }
                    }
                )
            })
        })
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/managementButtons/util/UserInfoRepository.js